
import { hasHtmlContent } from "../Utils/htmlStringUtils";

const InputCorrection = props => {
  const { correctionText } = props;

  if (!hasHtmlContent(correctionText)) return null;

  return (
    <div className="form-check-correction-text">
      <div className="form-correction">
        <p>{correctionText}</p>
      </div>
    </div>
  );
};

export default InputCorrection;
